import { FC } from 'react';
import CardForm, { CardFormProps } from '../CardForm';
import SearchFormItem from './subpage/searchFormItem';
import {
  BaseSearchFormItemProps,
  SearchFormItemEnum,
} from './interface/baseInterface';

export interface SearchFormCardFormProps extends BaseSearchFormItemProps {
  /** 卡片表单参数 */
  cardFormProps?: CardFormProps;
}
/** 卡片表单 */
export const SearchFormCardForm: FC<SearchFormCardFormProps> = props => {
  const {
    cardFormProps,
    isDetail,
    testId,
    name,
    label,
    rules,
    hideLabel,
    ...resProps
  } = props;
  return (
    <SearchFormItem name={name} {...resProps} hideLabel={hideLabel || !label} label={label} rules={rules}>
      <CardForm
        disabled={isDetail}
        {...cardFormProps}
        test-id={`${testId}-${name}`}
      />
    </SearchFormItem>
  );
};

SearchFormCardForm.displayName =
  SearchFormItemEnum.SearchFormCardForm;

export default SearchFormCardForm;
